// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxxxlarge-superElipse-351a8822","strokeWidth":"super-ellipse-skins-xxxxlarge-strokeWidth-8988b5e7"};